module.exports = __webpack_public_path__ + "media/components/stylesheets/Gordita-MediumItalic-e4e72904b8db9642c5e585a43b0240a9.woff";